import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

import StepGroupParticipantsFormContainer from '../../../../containers/projects/StakeholderFormContainers/StepGroupParticipantsFormContainer.jsx';

const NewProfileStepGroupParticipants = ({ projectId, slug }) => (
  <>
    <Helmet>
      <title>New Stakeholder | ChangeSync</title>
    </Helmet>
    <StepGroupParticipantsFormContainer projectId={projectId} slug={slug} />
  </>
);

NewProfileStepGroupParticipants.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(NewProfileStepGroupParticipants));
